const TRUSTED_UPDATE_DOWNLOAD_HOSTS = [
  'kinetichosting.com',
  'kinetichosting.net',
  'kinetichosting.gg',
  'kineticpanel.com',
  'kineticpanel.net',
  'github.com',
  'githubusercontent.com',
  'release-assets.githubusercontent.com',
  'objects.githubusercontent.com'
];

const normalizeHost = (host) => String(host || '').trim().toLowerCase();

const isAllowedHost = (host, allowedHosts) => {
  const normalizedHost = normalizeHost(host);
  return allowedHosts.some((entry) => {
    const normalizedEntry = normalizeHost(entry);
    return normalizedHost === normalizedEntry || normalizedHost.endsWith(`.${normalizedEntry}`);
  });
};

export const normalizeTrustedExternalUrl = (
  value,
  { allowedHosts = [], allowedProtocols = ['https:'] } = {}
) => {
  let parsed;
  try {
    parsed = new URL(String(value || ''));
  } catch {
    throw new Error('Invalid external URL.');
  }

  if (!allowedProtocols.includes(parsed.protocol)) {
    throw new Error('External URL protocol is not allowed.');
  }

  if (allowedHosts.length > 0 && !isAllowedHost(parsed.hostname, allowedHosts)) {
    throw new Error('External URL host is not allowed.');
  }

  return parsed.toString();
};

export const normalizeTrustedUpdateDownloadUrl = (value) =>
  normalizeTrustedExternalUrl(value, {
    allowedHosts: TRUSTED_UPDATE_DOWNLOAD_HOSTS,
    allowedProtocols: ['https:']
  });

export const isTrustedUpdateDownloadUrl = (value) => {
  try {
    normalizeTrustedUpdateDownloadUrl(value);
    return true;
  } catch {
    return false;
  }
};
